module.exports = __webpack_public_path__ + "static/media/chatbot-avatar-reflect.57c05d34.png";